
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});

parcelRegister("lW4bD", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", function () { return $ff82431dc1dc3028$export$bdfd709ae4826697; }, function (v) { return $ff82431dc1dc3028$export$bdfd709ae4826697 = v; });
// TODO: convert this file to ESM once HMR issues are resolved
var $ff82431dc1dc3028$export$5a759dc7a1cfb72a;
var $ff82431dc1dc3028$export$bdfd709ae4826697;
var $ff82431dc1dc3028$export$c9e73fbda7da57b6;
"use strict";
const $ff82431dc1dc3028$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $ff82431dc1dc3028$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $ff82431dc1dc3028$var$getBundleURLCached(id, inputError) {
    let value = $ff82431dc1dc3028$var$bundleURL[id];
    if (!value) {
        value = $ff82431dc1dc3028$var$getBundleURL(inputError);
        $ff82431dc1dc3028$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $ff82431dc1dc3028$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $ff82431dc1dc3028$var$getBundleURL(inputError) {
    try {
        throw inputError !== null && inputError !== void 0 ? inputError : new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($ff82431dc1dc3028$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ff82431dc1dc3028$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $ff82431dc1dc3028$var$getOrigin(url) {
    return new URL(url).origin;
}
$ff82431dc1dc3028$export$5a759dc7a1cfb72a = $ff82431dc1dc3028$var$getOrigin;
$ff82431dc1dc3028$export$bdfd709ae4826697 = $ff82431dc1dc3028$var$getBundleURLCached;
$ff82431dc1dc3028$export$c9e73fbda7da57b6 = $ff82431dc1dc3028$var$getBaseURL;

});

parcelRegister("9xKEy", function(module, exports) {
$parcel$export(module.exports, "ChatWidgetProvider", function () { return $c6548387155117f6$export$a4cac963ae9f34ca; });
$parcel$export(module.exports, "default", function () { return $c6548387155117f6$export$2e2bcd8739ae039; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jIe84 = parcelRequire("jIe84");
var $ac0eX = parcelRequire("ac0eX");
var $6NMje = parcelRequire("6NMje");
var $aCV3p = parcelRequire("aCV3p");

var $fuLgT = parcelRequire("fuLgT");

var $9dCmO = parcelRequire("9dCmO");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");

var $j2b52 = parcelRequire("j2b52");

var $gx3aw = parcelRequire("gx3aw");

var $3riD8 = parcelRequire("3riD8");

var $kEjoI = parcelRequire("kEjoI");

// Load omni-channel UI only on the client when widget is open to avoid SSR 503 (Tesseract)
const $c6548387155117f6$var$ChatWidgetOmniChannelUI = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("88Flk")));

// Lazy-load analytics when fetchChatConnectionConfig succeeds (keeps @atlassian/omni-channel out of main bundle)
const $c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("6RJ0J")));

// Lazy-load analytics when fetchToken fails (same chunk as customer-joined analytics)
const $c6548387155117f6$var$ChatWidgetTokenErrorAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("6RJ0J")).then((m)=>({
            default: m.ChatWidgetTokenErrorAnalytics
        })));

// Lazy-load analytics when fetchChatConnectionConfig succeeds
const $c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("6RJ0J")).then((m)=>({
            default: m.ChatWidgetConnectionConfigSuccessAnalytics
        })));

// Lazy-load analytics when fetchToken succeeds (channelPlatformTokenError empty or null)
const $c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>// @ts-expect-error - extension-less path; bundler resolves correctly
    (parcelRequire("6RJ0J")).then((m)=>({
            default: m.ChatWidgetTokenSuccessAnalytics
        })));
const $c6548387155117f6$export$8a240b2f27c2948f = (url)=>{
    try {
        const urlObj = new URL(url);
        let pathname = urlObj.pathname.replace(/\/+$/, "");
        if (pathname.startsWith("/wac/")) pathname = pathname.slice(4);
        return pathname.replace(/^\/+/, "");
    } catch (e) {
        const match = /\/\/[^/]+(\/[^#?]*)/.exec(url);
        if (match === null || match === void 0 ? void 0 : match[1]) {
            let pathname = match[1].replace(/\/+$/, "");
            if (pathname.startsWith("/wac/")) pathname = pathname.slice(4);
            return pathname.replace(/^\/+/, "");
        }
        return "";
    }
};
const $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH = {
    "software/jira/product-discovery": {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/jira/service-management": {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/jira": {
        contactFlowId: "1825e6f7-75fc-47e2-b634-98923fa4a3b1",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom": {
        contactFlowId: "dc335c33-9da5-4291-842b-80956f53d2b7",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/loom-confluence": {
        contactFlowId: "7cf56869-3db7-431e-8311-b524e6065934",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/loom-jira": {
        contactFlowId: "199f4750-6436-4b88-a2db-c2b87c1bdaed",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/resources": {
        contactFlowId: "eadd2afc-29bb-4e9c-a0d6-370fd70186eb",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/ai-meeting": {
        contactFlowId: "364f6abb-5628-41c1-bf90-b3ca2486378d",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "software/loom/editing": {
        contactFlowId: "a4addd51-eb96-46fc-b5a9-3f99c3d923de",
        formKey: [
            "ca-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/company/contact/japan": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/service-management": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/pricing": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/confluence": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/confluence/pricing": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    },
    "ja/software/jira/service-management/pricing": {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            "jpns-growth-pricing-billing-and-licensing"
        ]
    }
};
const $c6548387155117f6$export$a8ad7472af635967 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    var _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath;
    return (_CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath]) !== null && _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath !== void 0 ? _CHAT_SUPPORT_CONFIG_BY_URL_PATH_normalizedPath : {
        contactFlowId: ""
    };
};
const $c6548387155117f6$export$b28607ea792e8283 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && Array.isArray(entry.formKey)) return entry.formKey;
    return [
        ""
    ];
};
const $c6548387155117f6$export$39f87d2399b576ea = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && typeof entry.attributes === "object" && entry.attributes !== null) return JSON.stringify(entry.attributes, null, 2);
    return "{}";
};
const $c6548387155117f6$export$c452173f1b4082d7 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, "");
    return normalizedPath === "ja" || normalizedPath.startsWith("ja/");
};
const $c6548387155117f6$export$8378cdc69cfc311a = (url)=>{
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        // Remove leading and trailing slashes, then split by '/' and filter out empty strings
        const pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/").filter((part)=>part.length > 0);
        // Join with underscores
        return pathParts.join("_");
    } catch (error) {
        // If URL parsing fails, try to extract path manually
        const match = /\/\/[^\/]+(\/[^?#]*)/.exec(url);
        if (match && match[1]) {
            const pathname = match[1];
            const pathParts = pathname.replace(/^\/+|\/+$/g, "").split("/").filter((part)=>part.length > 0);
            return pathParts.join("_");
        }
        return "";
    }
};
const $c6548387155117f6$export$2b66390f6eecea5c = (payload)=>{
    const transformed = {};
    if (!payload) return transformed;
    Object.entries(payload).forEach(([key, value])=>{
        // Skip attachments
        if (key === "attachments") return;
        // Skip null or undefined values
        if (value === null || value === undefined) return;
        // Handle arrays - normalize to array of strings
        if (Array.isArray(value)) transformed[key] = value.map((v)=>{
            // If array element is an object (like {userEmail: "value"}), extract the first value
            if (typeof v === "object" && v !== null && !Array.isArray(v)) {
                const firstValue = Object.values(v)[0];
                return firstValue !== undefined ? String(firstValue) : String(v);
            }
            // Already a string or primitive
            return String(v);
        });
        else transformed[key] = [
            String(value)
        ];
    });
    return transformed;
};
const $c6548387155117f6$export$a40d7197cc58cf92 = (payload)=>{
    return JSON.stringify(payload);
};
const $c6548387155117f6$export$6999922c2cdd8944 = (chatConnectionConfigResponse)=>{
    const submitRequest = chatConnectionConfigResponse === null || chatConnectionConfigResponse === void 0 ? void 0 : chatConnectionConfigResponse.channelPlatform_createContact;
    return {
        channelPlatform_submitRequest: submitRequest
    };
};
function $c6548387155117f6$export$c0c7c314cc68764f(config) {
    var _contact_value;
    const contact = config === null || config === void 0 ? void 0 : config.channelPlatform_createContact;
    return contact === null || contact === void 0 ? void 0 : (_contact_value = contact.value) === null || _contact_value === void 0 ? void 0 : _contact_value.contactId;
}
function $c6548387155117f6$export$f0671fd2506d780c(config) {
    const contact = config === null || config === void 0 ? void 0 : config.channelPlatform_createContact;
    const value = contact === null || contact === void 0 ? void 0 : contact.value;
    return {
        contactId: value === null || value === void 0 ? void 0 : value.contactId,
        participantId: value === null || value === void 0 ? void 0 : value.participantId,
        region: value === null || value === void 0 ? void 0 : value.region
    };
}
function $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail, isUserLoggedIn) {
    return {
        cst_support_forms_data_fieldDescMap: [
            '{"inquiry_category":"Inquiry Category","email":"Email","raised_obo_by":"Raised on behalf of by","language":"language","customer_working_hours":"Support Business Hours Select"}'
        ],
        customer_email: [
            isUserLoggedIn ? userEmail : ""
        ],
        authenticated: isUserLoggedIn ? null : [
            "No"
        ],
        email: [
            isUserLoggedIn ? userEmail : ""
        ],
        customer_status: [
            "Customer"
        ],
        cst_support_forms_data_formKey: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_formLabel: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_timezone: [
            "GMT+6"
        ],
        referral_url: [
            window.location.href
        ],
        language: [
            "en"
        ],
        is_partner_dc_exception: [
            "Customer not in SFDC"
        ],
        topic: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href)
        ],
        summary: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href).split("_").join(" ")
        ],
        support_channel: [
            "chat"
        ],
        inquiry_category: [
            "access_issues"
        ],
        cst_support_forms_data_contextId: [
            contextId
        ]
    };
}
function $c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasOpenCurrent, clientToken, clientWithToken) {
    return isWidgetOpen && !wasOpenCurrent && !!clientToken && !!clientWithToken;
}
function $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn) {
    return {
        flowId: $c6548387155117f6$export$a8ad7472af635967($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)).contactFlowId,
        formContext: {
            summary: [
                "Chat Transcript for <email removed for privacy>"
            ],
            details: "",
            contactEmail: isUserLoggedIn ? userEmail !== null && userEmail !== void 0 ? userEmail : "" : "",
            isAuthenticated: isUserLoggedIn
        }
    };
}
function $c6548387155117f6$var$hasCustomerConversations(response) {
    var _response_channelPlatform_getCustomerConversations_conversations, _response_channelPlatform_getCustomerConversations;
    var _response_channelPlatform_getCustomerConversations_conversations_length;
    const count = (_response_channelPlatform_getCustomerConversations_conversations_length = response === null || response === void 0 ? void 0 : (_response_channelPlatform_getCustomerConversations = response.channelPlatform_getCustomerConversations) === null || _response_channelPlatform_getCustomerConversations === void 0 ? void 0 : (_response_channelPlatform_getCustomerConversations_conversations = _response_channelPlatform_getCustomerConversations.conversations) === null || _response_channelPlatform_getCustomerConversations_conversations === void 0 ? void 0 : _response_channelPlatform_getCustomerConversations_conversations.length) !== null && _response_channelPlatform_getCustomerConversations_conversations_length !== void 0 ? _response_channelPlatform_getCustomerConversations_conversations_length : 0;
    return count > 0;
}
function $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded) {
    const isChatLoaded = isWidgetOpen && !!clientToken && !!chatConnectionConfig && isCustomerComponentLoaded;
    return {
        isChatLoaded: isChatLoaded,
        showFloatingButton: !isChatLoaded,
        isButtonLoading: isWidgetOpen && (!clientToken || !chatConnectionConfig || !isCustomerComponentLoaded)
    };
}
const $c6548387155117f6$var$ChatFloatingButton = ({ isLoading: isLoading, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": isLoading ? "Loading chat" : "Open chat widget",
        style: {
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 1000,
            cursor: isLoading ? "wait" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "56px",
            height: "56px",
            borderRadius: "50%",
            backgroundColor: (0, $kbpa7.wacToken)("color.primary.blue"),
            color: "white",
            boxShadow: (0, $lP7A9.default)("elevation.shadow.raised")
        },
        onClick: onClick,
        onKeyDown: onKeyDown,
        children: isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "medium",
            label: "Loading chat",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dCmO))), {
            label: "",
            size: "medium",
            color: "currentColor"
        })
    });
};
function $c6548387155117f6$var$useChatWidgetConnection({ isWidgetOpen: isWidgetOpen, contextId: contextId, userEmail: userEmail, isUserLoggedIn: isUserLoggedIn, setIsCustomerComponentLoaded: setIsCustomerComponentLoaded }) {
    const [clientToken, setClientToken] = (0, $1oC0p.useState)(null);
    const [chatConnectionConfig, setChatConnectionConfig] = (0, $1oC0p.useState)(null);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    const [channelPlatformTokenError, setChannelPlatformTokenError] = (0, $1oC0p.useState)(null);
    const [customerConversationsResponse, setCustomerConversationsResponse] = (0, $1oC0p.useState)(null);
    const generateAuthHeader = (channelsIdentityHash)=>new (0, $ac0eX.ApolloLink)((operation, forward)=>{
            operation.setContext(({ headers: headers = {} })=>({
                    headers: (0, $dPABA._)((0, $6ogO3._)({}, headers), {
                        "Content-Type": "application/json",
                        "X-Client-Hash": channelsIdentityHash
                    })
                }));
            return forward(operation);
        });
    const client = (0, $1oC0p.useMemo)(()=>{
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: "include"
        });
        return new (0, $jIe84.ApolloClient)({
            link: link,
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, []);
    const wasWidgetOpenRef = (0, $1oC0p.useRef)(false);
    const clientWithToken = (0, $1oC0p.useMemo)(()=>{
        if (!clientToken) return null;
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: "include"
        });
        return new (0, $jIe84.ApolloClient)({
            link: (0, $ac0eX.ApolloLink).from([
                generateAuthHeader(clientToken),
                link
            ]),
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, [
        clientToken
    ]);
    const isRefreshed = (0, $1oC0p.useMemo)(()=>$c6548387155117f6$var$hasCustomerConversations(customerConversationsResponse), [
        customerConversationsResponse
    ]);
    const fetchCustomerConversations = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) return;
        const anonymousId = (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || "";
        clientWithToken.query({
            query: (0, $kEjoI.getCustomerConversations),
            variables: {
                anonymousId: anonymousId
            }
        }).then((response)=>{
            var _response_data;
            setCustomerConversationsResponse((_response_data = response === null || response === void 0 ? void 0 : response.data) !== null && _response_data !== void 0 ? _response_data : null);
        }).catch((err)=>{
            console.warn("Error fetching customer conversations:", err);
            setCustomerConversationsResponse(null);
        });
    }, [
        clientWithToken
    ]);
    const fetchChatConnectionConfig = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) {
            console.warn("Client with token not available yet");
            return;
        }
        setLoading(true);
        const formValues = $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail !== null && userEmail !== void 0 ? userEmail : "", isUserLoggedIn);
        var _JSON_parse;
        clientWithToken.query({
            query: (0, $kEjoI.getChatConnectionConfigForSalesChannel),
            variables: {
                requestType: "CHAT",
                payload: $c6548387155117f6$export$2b66390f6eecea5c(formValues),
                metadata: $c6548387155117f6$export$a40d7197cc58cf92($c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn)),
                attributes: (_JSON_parse = JSON.parse($c6548387155117f6$export$39f87d2399b576ea($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)))) !== null && _JSON_parse !== void 0 ? _JSON_parse : {},
                anonymousId: (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id") || ""
            }
        }).then((response)=>{
            setChatConnectionConfig(response === null || response === void 0 ? void 0 : response.data);
            setLoading(false);
        }).catch((err)=>{
            console.error("Error fetching chat connection config:", err);
            setError(err);
            setLoading(false);
        });
    }, [
        clientWithToken,
        contextId,
        isUserLoggedIn,
        userEmail
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if ($c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasWidgetOpenRef.current, clientToken, clientWithToken)) {
            wasWidgetOpenRef.current = true;
            fetchCustomerConversations();
            fetchChatConnectionConfig();
        }
        if (!isWidgetOpen) {
            wasWidgetOpenRef.current = false;
            setIsCustomerComponentLoaded(false);
        }
    }, [
        isWidgetOpen,
        clientToken,
        clientWithToken,
        fetchCustomerConversations,
        fetchChatConnectionConfig,
        setIsCustomerComponentLoaded
    ]);
    const fetchToken = (0, $1oC0p.useCallback)(()=>{
        setLoading(true);
        client.query({
            query: (0, $kEjoI.getChannelPlatformTokenByClientName),
            variables: {
                clientName: "sales"
            }
        }).then((response)=>{
            var _response_data;
            const token = (_response_data = response.data) === null || _response_data === void 0 ? void 0 : _response_data.supportInquiry_channelsIdentityHashByClientName;
            if (token) {
                setClientToken(token);
                setChannelPlatformTokenError(null);
            }
            setLoading(false);
        }).catch((err)=>{
            console.error("Error fetching channel platform token:", err);
            setError(err);
            setLoading(false);
            const errorMessage = err instanceof Error ? err.message : String(err);
            setChannelPlatformTokenError(errorMessage);
        });
    }, [
        client
    ]);
    return {
        clientToken: clientToken,
        chatConnectionConfig: chatConnectionConfig,
        loading: loading,
        error: error,
        channelPlatformTokenError: channelPlatformTokenError,
        client: client,
        clientWithToken: clientWithToken,
        isRefreshed: isRefreshed,
        customerConversationsResponse: customerConversationsResponse,
        setClientToken: setClientToken,
        fetchToken: fetchToken
    };
}
const $c6548387155117f6$export$a4cac963ae9f34ca = ({ children: children })=>{
    const [isWidgetOpen, setIsWidgetOpen] = (0, $1oC0p.useState)(false);
    const [isCustomerComponentLoaded, setIsCustomerComponentLoaded] = (0, $1oC0p.useState)(false);
    const { accountId: aaid, email: userEmail, isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const contextId = (0, $1oC0p.useMemo)(()=>(0, $fuLgT.default)(), []);
    const connection = $c6548387155117f6$var$useChatWidgetConnection({
        isWidgetOpen: isWidgetOpen,
        contextId: contextId,
        userEmail: userEmail,
        isUserLoggedIn: isUserLoggedIn,
        setIsCustomerComponentLoaded: setIsCustomerComponentLoaded
    });
    const { clientToken: clientToken, chatConnectionConfig: chatConnectionConfig, loading: loading, error: error, channelPlatformTokenError: channelPlatformTokenError, isRefreshed: isRefreshed, customerConversationsResponse: customerConversationsResponse } = connection;
    const surveyModalAttributes = {
        width: "80%",
        height: 500
    };
    const omniChannelEnv = "production";
    const handleChatButtonClick = ()=>{
        const opening = !isWidgetOpen;
        setIsWidgetOpen(opening);
        if (opening) connection.fetchToken();
    };
    const handleChatButtonKeyDown = (event)=>{
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleChatButtonClick();
        }
    };
    const viewState = $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded);
    const showChatPanel = isWidgetOpen && !!chatConnectionConfig && !!clientToken;
    const conversationId = $c6548387155117f6$export$c0c7c314cc68764f(chatConnectionConfig);
    const connectionConfigAttributes = $c6548387155117f6$export$f0671fd2506d780c(chatConnectionConfig);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                children,
                chatConnectionConfig && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics, {
                            conversationId: conversationId
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics, {
                            contactId: connectionConfigAttributes.contactId,
                            participantId: connectionConfigAttributes.participantId,
                            region: connectionConfigAttributes.region
                        })
                    ]
                }),
                channelPlatformTokenError && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenErrorAnalytics, {
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                clientToken && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics, {
                        clientToken: clientToken,
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                viewState.showFloatingButton && /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatFloatingButton, {
                    isLoading: viewState.isButtonLoading,
                    onClick: handleChatButtonClick,
                    onKeyDown: handleChatButtonKeyDown
                }),
                showChatPanel && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetOmniChannelUI, {
                        env: omniChannelEnv,
                        clientIdentityHash: clientToken || "",
                        chatContactDetails: $c6548387155117f6$export$6999922c2cdd8944(chatConnectionConfig),
                        accountId: aaid || "",
                        isRefreshed: isRefreshed,
                        customerConversations: customerConversationsResponse,
                        loading: loading,
                        error: error,
                        isUserLoggedIn: isUserLoggedIn,
                        surveyModalAttributes: surveyModalAttributes,
                        onLoaded: ()=>setIsCustomerComponentLoaded(true)
                    })
                })
            ]
        })
    });
};
var $c6548387155117f6$export$2e2bcd8739ae039 = $c6548387155117f6$export$a4cac963ae9f34ca;

});
parcelRegister("kEjoI", function(module, exports) {
$parcel$export(module.exports, "getChatConnectionConfigForSalesChannel", function () { return $59b9792633dffc77$export$2fedc4b0d22f20b3; });
$parcel$export(module.exports, "getCustomerConversations", function () { return $59b9792633dffc77$export$54e9b7f1aad2199a; });
$parcel$export(module.exports, "getChannelPlatformTokenByClientName", function () { return $59b9792633dffc77$export$c543cd67c9b21e36; });
// @ts-expect-error - @apollo/client is ESM but this file is treated as CommonJS by TypeScript

var $4Wqet = parcelRequire("4Wqet");
let $59b9792633dffc77$var$_ = (t)=>t, $59b9792633dffc77$var$t, $59b9792633dffc77$var$t1, $59b9792633dffc77$var$t2, $59b9792633dffc77$var$t3, $59b9792633dffc77$var$t4;
const $59b9792633dffc77$export$51e62cbd534f416c = (0, $4Wqet.gql)($59b9792633dffc77$var$t || ($59b9792633dffc77$var$t = $59b9792633dffc77$var$_`
    query channelPlatformTokenGeneration {
        supportInquiry_channelsIdentityHash
    }
`));
const $59b9792633dffc77$export$2fedc4b0d22f20b3 = (0, $4Wqet.gql)($59b9792633dffc77$var$t1 || ($59b9792633dffc77$var$t1 = $59b9792633dffc77$var$_`
    query CreateContact(
        $requestType: ChannelPlatformChannelType!
        $payload: JSON
        $metadata: JSON
        $anonymousId: String
        $attributes: JSON
    ) {
        channelPlatform_createContact(
            requestType: $requestType
            request: {
                payload: $payload
                metadata: $metadata
                attributes: $attributes
            }
            anonymousId: $anonymousId
        ) {
            channel
            value {
                ... on ChannelPlatformGetChannelTokenResponse {
                    participantId
                    participantToken
                    region
                    contactId
                }
            }
        }
    }
`));
const $59b9792633dffc77$export$54e9b7f1aad2199a = (0, $4Wqet.gql)($59b9792633dffc77$var$t2 || ($59b9792633dffc77$var$t2 = $59b9792633dffc77$var$_`
    query CustomerConversations($anonymousId: String) {
        channelPlatform_getCustomerConversations(anonymousId: $anonymousId) {
            conversations
        }
    }
`));
const $59b9792633dffc77$export$f843774d31ce9c0c = (0, $4Wqet.gql)($59b9792633dffc77$var$t3 || ($59b9792633dffc77$var$t3 = $59b9792633dffc77$var$_`
    query CreateContact(
        $requestType: ChannelPlatformChannelType!
        $payload: JSON
        $metadata: JSON
    ) {
        channelPlatform_createContact(
            requestType: $requestType
            request: { payload: $payload, metadata: $metadata }
        ) {
            channel
            value {
                ... on ChannelPlatformGetChannelTokenResponse {
                    participantId
                    participantToken
                    region
                    contactId
                }
            }
        }
    }
`));
const $59b9792633dffc77$export$c543cd67c9b21e36 = (0, $4Wqet.gql)($59b9792633dffc77$var$t4 || ($59b9792633dffc77$var$t4 = $59b9792633dffc77$var$_`
    query channelPlatformTokenGenerationByClientName($clientName: String) {
        supportInquiry_channelsIdentityHashByClientName(
            request: { clientName: $clientName }
        )
    }
`));

});

parcelRegister("88Flk", function(module, exports) {
























module.exports = Promise.all([
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("1UZeW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("eDmkW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("2TJ5h")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("8vPuH")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("hCwjc")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("eCxpc")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("6JxfS")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("HRjDP")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("9WEDO")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("gFcxC")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("7Q4ht")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("76kmj"))
]).then(()=>parcelRequire('8Cs4z'));

});
parcelRegister("1athW", function(module, exports) {
"use strict";

var $1tHQt = parcelRequire("1tHQt");
module.exports = $1tHQt(function importModule(bundle) {
    return new Promise((resolve, reject)=>{
        // Add a global function to handle when the script loads.
        let globalName = `i${('' + Math.random()).slice(2)}`;
        $parcel$global[globalName] = (m)=>{
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        let cleanup = ()=>{
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        let script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = `import * as m from '${bundle}'; ${globalName}(m);`;
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("1tHQt", function(module, exports) {
"use strict";
let $113a82a87c54a561$var$cachedBundles = {};
let $113a82a87c54a561$var$cachedPreloads = {};
let $113a82a87c54a561$var$cachedPrefetches = {};
function $113a82a87c54a561$var$getCache(type) {
    switch(type){
        case 'preload':
            return $113a82a87c54a561$var$cachedPreloads;
        case 'prefetch':
            return $113a82a87c54a561$var$cachedPrefetches;
        default:
            return $113a82a87c54a561$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $113a82a87c54a561$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("6RJ0J", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("1UZeW")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("hCwjc")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("hx68B"))
]).then(()=>parcelRequire('cJIcN'));

});


var $82ceb0c791b0915c$exports = {};


(parcelRequire("hwrhg")).register((parcelRequire("lW4bD")).getBundleURL('7riGl'), JSON.parse("[\"7riGl\",\"jira-product-discovery-page.d64e4cbe.js\",\"76kmj\",\"chat-widget-omni-channel-ui.a603c3a7.js\",\"6Hc2y\",\"modal.b87d1664.js\",\"lq0Jz\",\"modal.748eec6e.js\",\"hdFVX\",\"custom-theme.baeb4819.js\",\"7gQUy\",\"atlassian-light.9f8d24a2.js\",\"8PkqS\",\"atlassian-light-future.c7ebcb5a.js\",\"d1UJM\",\"atlassian-light-increased-contrast.cad7b512.js\",\"5zUWn\",\"atlassian-dark.4192547b.js\",\"bi7iI\",\"atlassian-dark-future.c93063e8.js\",\"8cEoG\",\"atlassian-dark-increased-contrast.a54f460f.js\",\"gJjFX\",\"atlassian-legacy-light.586a373a.js\",\"ec8ot\",\"atlassian-legacy-dark.21970367.js\",\"165OO\",\"atlassian-spacing.545fbcf0.js\",\"enFem\",\"atlassian-typography.16985989.js\",\"ekp1O\",\"atlassian-typography-adg3.118a73d9.js\",\"cFJQy\",\"atlassian-shape.7b9a7e53.js\",\"6oWPm\",\"atlassian-typography-modernized.62ea4c0e.js\",\"frMLF\",\"atlassian-typography-refreshed.870f00a6.js\",\"j7ZNh\",\"atlassian-light-brand-refresh.fbbfa86a.js\",\"c7cUo\",\"atlassian-dark-brand-refresh.3936562a.js\",\"9a6Xx\",\"datasourceRenderFailedAnalyticsWrapper.494853db.js\",\"gdywM\",\"datasourceTableView.2e881848.js\",\"3bip3\",\"custom-theme.fe0533c8.js\",\"ACdYc\",\"atlassian-light.76998b37.js\",\"fMuOF\",\"atlassian-light-future.8adad6a9.js\",\"jFBYM\",\"atlassian-light-increased-contrast.f3bca38d.js\",\"bFRQv\",\"atlassian-dark.237033be.js\",\"9o3Qz\",\"atlassian-dark-future.d05964e7.js\",\"3ywKA\",\"atlassian-dark-increased-contrast.f1846843.js\",\"jfOwk\",\"atlassian-legacy-light.1e3dfb4d.js\",\"4dofZ\",\"atlassian-legacy-dark.a73ec679.js\",\"5kOR7\",\"atlassian-spacing.761caaa8.js\",\"bm1Ml\",\"atlassian-typography.883267ee.js\",\"kt58Z\",\"atlassian-shape.a598653d.js\",\"iCZTw\",\"dark.16cc06e7.svg\",\"eVZsY\",\"light.e350f7db.svg\",\"8f4hZ\",\"dark.981334ac.svg\",\"kydQZ\",\"light.d61b1f64.svg\",\"jHnnv\",\"custom-theme.a0c8ec4b.js\",\"5ak2J\",\"atlassian-light.ba05ae79.js\",\"4Pk1J\",\"atlassian-light-future.04859521.js\",\"MqMfP\",\"atlassian-light-increased-contrast.14b6e884.js\",\"dzbhG\",\"atlassian-dark.339c992e.js\",\"lHxuI\",\"atlassian-dark-future.d7cdbc87.js\",\"eMQ7i\",\"atlassian-dark-increased-contrast.d946f948.js\",\"j9IDT\",\"atlassian-legacy-light.2103277a.js\",\"98Db3\",\"atlassian-legacy-dark.55d279b9.js\",\"2oGEA\",\"atlassian-spacing.4b564a19.js\",\"6yuER\",\"atlassian-typography.7c8ca7f6.js\",\"8fMi7\",\"atlassian-shape.97c646d0.js\",\"lzCLl\",\"dark.90199792.svg\",\"8quzl\",\"light.5ffcf568.svg\",\"cvzoR\",\"custom-theme.ba812f82.js\",\"7wlKU\",\"atlassian-light.630c1e9e.js\",\"utH2W\",\"atlassian-light-future.65d80e57.js\",\"hLvhF\",\"atlassian-light-increased-contrast.7ebaf685.js\",\"9Uujq\",\"atlassian-dark.904d3abf.js\",\"j5eab\",\"atlassian-dark-future.5b2423ad.js\",\"gauaU\",\"atlassian-dark-increased-contrast.6ed72b5c.js\",\"k8Gkh\",\"atlassian-legacy-light.81977962.js\",\"3YcId\",\"atlassian-legacy-dark.818da115.js\",\"bujnc\",\"atlassian-spacing.c480601a.js\",\"10i7Q\",\"atlassian-typography.f5cda6aa.js\",\"7LKBZ\",\"atlassian-shape.23f82126.js\",\"gtQ8k\",\"custom-theme.79e2e8cb.js\",\"jfuoo\",\"atlassian-light.a5a7eecb.js\",\"7APz7\",\"atlassian-light-future.457b9286.js\",\"iFOS9\",\"atlassian-light-increased-contrast.68bc9c4d.js\",\"4P4XE\",\"atlassian-dark.bc5cf9e0.js\",\"daf02\",\"atlassian-dark-future.3d6b0ea0.js\",\"bna3i\",\"atlassian-dark-increased-contrast.dc6e588b.js\",\"fXc4y\",\"atlassian-legacy-light.1d3e741e.js\",\"2n8qk\",\"atlassian-legacy-dark.29a38254.js\",\"4Odc8\",\"atlassian-spacing.bfc86e56.js\",\"hWxEJ\",\"atlassian-typography.04812642.js\",\"ieJVO\",\"atlassian-shape.1c75f204.js\",\"liGvy\",\"component-lazy.5a2ea5e6.js\",\"aXHfO\",\"file-icon.e5d19bc4.js\",\"8Gud5\",\"chart-bar-icon.3ca286f8.js\",\"9rbe5\",\"list-bullet-icon.cf4783dd.js\",\"8DwmE\",\"component-lazy.7e15be47.js\",\"hc6ft\",\"file--document-filled.2c71406a.js\",\"gAaTd\",\"people-group.4ed8f032.js\",\"9yG1J\",\"16.802eb9cc.js\",\"8hdJi\",\"16.ed9c024c.js\",\"8EkaQ\",\"16.ebbb21b0.js\",\"ea9vx\",\"16.06bde39a.js\",\"2DITZ\",\"16.c6bcd751.js\",\"9ysOW\",\"16.3a9dec64.js\",\"d3VeM\",\"16.5bdba732.js\",\"f185M\",\"16.4fef52e9.js\",\"bP6QH\",\"16.0fc84761.js\",\"iIiz1\",\"16.f208d690.js\",\"jlnZV\",\"16.53ea51f0.js\",\"49rYz\",\"16.f8ee7e55.js\",\"f5THM\",\"16.b5d50168.js\",\"kjiF8\",\"manual-triggers-modal.612a35fb.js\",\"fS5aw\",\"component-lazy.f5ec959c.js\",\"cNqyk\",\"custom-theme.793a518d.js\",\"67G18\",\"atlassian-light.3c9acf67.js\",\"9aHW1\",\"atlassian-light-future.a474110a.js\",\"58YkL\",\"atlassian-light-increased-contrast.9678435f.js\",\"lYtLB\",\"atlassian-dark.7e480ae6.js\",\"hN1k8\",\"atlassian-dark-future.6ad04215.js\",\"2vgig\",\"atlassian-dark-increased-contrast.813159e2.js\",\"2Z9sD\",\"atlassian-legacy-light.8443c7c2.js\",\"6Z3Ag\",\"atlassian-legacy-dark.b6c698c9.js\",\"7sysd\",\"atlassian-spacing.8aec7d75.js\",\"4lKL9\",\"atlassian-typography.f80b94e3.js\",\"2LUz0\",\"atlassian-typography-adg3.f25d4b34.js\",\"aDLAv\",\"atlassian-shape.16fd7514.js\",\"l7WJj\",\"atlassian-shape-rounder.d5bc9c87.js\",\"9qg9C\",\"atlassian-shape-roundest.dd5530eb.js\",\"8Xrqp\",\"atlassian-typography-modernized.a511784f.js\",\"aJe4E\",\"atlassian-typography-refreshed.8701311d.js\",\"ZOcdO\",\"atlassian-light-brand-refresh.da963d75.js\",\"d7t6F\",\"atlassian-dark-brand-refresh.a0f3ec78.js\",\"bTaOO\",\"audio-icon.139ce297.js\",\"jkouq\",\"angle-brackets-icon.a1953bb1.js\",\"eyGRK\",\"folder-icon.72a47762.js\",\"90sX7\",\"image-icon.5b9cb68e.js\",\"kCVhd\",\"video-icon.d573330b.js\",\"2E2HA\",\"lock-locked--lock-filled.66df3c76.js\",\"lRI2Y\",\"16.8f07bf42.js\",\"fWWE5\",\"24.2111ca9a.js\",\"8o7Ts\",\"16.fce55b0c.js\",\"cFvqv\",\"24.1f8934e9.js\",\"eOvUw\",\"16.86616f8b.js\",\"nm140\",\"24.c96f6bb7.js\",\"6CuKg\",\"16.930f4eda.js\",\"k9hlb\",\"24.90f9251e.js\",\"8G5eK\",\"16.7420688e.js\",\"9ri2N\",\"24.83a4bfc2.js\",\"93J0M\",\"16.a1870f18.js\",\"lrPIC\",\"24.ecdcfda1.js\",\"58qCs\",\"16.e5491c6d.js\",\"kZbQK\",\"24.d2147987.js\",\"lgPBh\",\"16.17d3c819.js\",\"iZF5R\",\"24.d01f06c9.js\",\"8I81U\",\"16.1fd0985e.js\",\"hT09x\",\"24.700b2056.js\",\"cwE10\",\"16.c8df3df6.js\",\"aCrGD\",\"24.096b0231.js\",\"8HMJx\",\"16.2bbb6077.js\",\"dvNrH\",\"24.fb4daace.js\",\"9lj4x\",\"16.a95594a7.js\",\"jtSYT\",\"24.21fd45cf.js\",\"cxK3I\",\"24.1882ac9a.js\",\"dPh4e\",\"24.ba248b2a.js\",\"9YeU5\",\"24.c23c58b8.js\",\"6plOw\",\"24.8172ed1a.js\",\"6NidY\",\"24.693c7bbd.js\",\"e0eIk\",\"24.acdc7f41.js\",\"95LIj\",\"24.fb369b83.js\",\"adbKr\",\"24.77a755ff.js\",\"d6tGh\",\"24.7aee3c43.js\",\"iefvr\",\"24.55334e55.js\",\"kPBg6\",\"24.5f1817e6.js\",\"kA9tL\",\"24.58ae2b41.js\",\"4SXK0\",\"24.ebcb9cdc.js\",\"j4Itt\",\"jira-icon.234d5702.js\",\"lib95\",\"attachment.71f8e409.js\",\"D5ka0\",\"task.127d40d3.js\",\"dXvbQ\",\"component.4c4a2f64.js\",\"1A6ym\",\"comment.7359d2ed.js\",\"8CMvx\",\"eye-open--watch.a70e81c3.js\",\"9dm3d\",\"thumbs-up--like.d33e05f8.js\",\"4zav0\",\"arrow-up.698597be.js\",\"l9PCY\",\"priority-blocker.0c6a1f47.js\",\"lRtmg\",\"priority-critical.fa9c52c5.js\",\"4lNLt\",\"priority-high.dd44b41c.js\",\"2oyYc\",\"priority-highest.a6526db4.js\",\"i4dsq\",\"priority-low.71553701.js\",\"lD1Rq\",\"priority-lowest.052875c0.js\",\"bgSXd\",\"priority-major.7bd3c028.js\",\"8z8vC\",\"priority-medium.26020ccf.js\",\"aEXtk\",\"priority-minor.2a5305da.js\",\"ck942\",\"priority-trivial.0b3e3f66.js\",\"e425q\",\"question-circle--question.dea3398d.js\",\"5rsU4\",\"angle-brackets--code.f86dfab4.js\",\"1pVQO\",\"people-group--people.35367801.js\",\"1ucEX\",\"subtasks--subtask.eda138e8.js\",\"UxexI\",\"goal-icon.80abae0b.js\",\"6nPL4\",\"projects-icon.72e5ba07.js\",\"y6CTt\",\"manual-triggers-modal.34021ef8.js\",\"jUgWl\",\"RelatedLinksModal.574e8ac3.js\",\"iRXom\",\"EmbedModal.e55d1ad0.js\",\"eBpIO\",\"modal.ac7aeadf.js\",\"65GSm\",\"custom-theme.e8b555aa.js\",\"lUmek\",\"atlassian-light.506ffb36.js\",\"4peld\",\"atlassian-light-future.a5259d9a.js\",\"4llBl\",\"atlassian-light-increased-contrast.cff77a43.js\",\"bL3YY\",\"atlassian-dark.e2dd6dc5.js\",\"9kHnf\",\"atlassian-dark-future.dc94014e.js\",\"5fMmr\",\"atlassian-dark-increased-contrast.ab068037.js\",\"9EhOv\",\"atlassian-legacy-light.13ff5e19.js\",\"8unrd\",\"atlassian-legacy-dark.8950fe4c.js\",\"1P55Z\",\"atlassian-spacing.c351347c.js\",\"6oZoF\",\"atlassian-typography.bfe44bcb.js\",\"lAp5q\",\"atlassian-shape.139e8647.js\",\"5NarU\",\"standard.6c3cc6ed.svg\",\"bHEL0\",\"datasourceTableView.7a45aa30.js\",\"gVnQ5\",\"modal.d292b15f.js\",\"5Wzj9\",\"atlassian-light.2fefe1e5.js\",\"ivh8f\",\"atlassian-light-future.60574f7b.js\",\"k6ugH\",\"atlassian-light-increased-contrast.ce5eda3e.js\",\"8RRF9\",\"atlassian-dark.f83df4bf.js\",\"dOD09\",\"atlassian-dark-future.dd5240ae.js\",\"bYBdr\",\"atlassian-dark-increased-contrast.04b78022.js\",\"kLSvv\",\"atlassian-legacy-light.63745787.js\",\"5zuOR\",\"atlassian-legacy-dark.f174e1c6.js\",\"huoAo\",\"atlassian-spacing.503ca616.js\",\"8rxXz\",\"atlassian-typography.5f5a04f9.js\",\"6Tsoz\",\"atlassian-shape.975eb309.js\",\"jkU33\",\"custom-theme.9f221f57.js\",\"6NSgp\",\"modal.7ee69e89.js\",\"lfhvm\",\"modal.047e77f8.js\",\"6glGi\",\"dark.725705dc.svg\",\"f3gSE\",\"light.bf58aa10.svg\",\"dDNE6\",\"modal.cc067905.js\",\"kYefW\",\"ParseTreePatternMatcher.da5957f9.js\",\"bImte\",\"atlassian-light.e818a1f9.js\",\"YWSML\",\"atlassian-light-future.3ae14ea8.js\",\"5eAdz\",\"atlassian-light-increased-contrast.6688b9f8.js\",\"iCyAG\",\"atlassian-dark.64843d8c.js\",\"dDr7s\",\"atlassian-dark-future.a801b807.js\",\"7SYj7\",\"atlassian-dark-increased-contrast.38aa9446.js\",\"61mbc\",\"atlassian-legacy-light.a559c507.js\",\"7AAVd\",\"atlassian-legacy-dark.5d8ebe47.js\",\"gXQJF\",\"atlassian-spacing.48d0368f.js\",\"4U4YY\",\"atlassian-typography.36e2254b.js\",\"1KFsN\",\"atlassian-shape.9f7ed679.js\",\"elT3n\",\"custom-theme.f80986f9.js\",\"68ulU\",\"provider.e66a3540.js\",\"g8cNi\",\"sha256SimpleHasher.9f3978d6.js\",\"fuffb\",\"sha256SimpleHasher.d94735af.js\",\"GVqlx\",\"simpleHasher.1951a957.js\",\"2TJ5h\",\"simpleHasher.9cdb997b.js\",\"bBWca\",\"mobile-upload.91124625.js\",\"6pCA8\",\"mobile-upload.8e2aa0eb.js\",\"iWZ7j\",\"emoji.b5936e39.js\",\"8krYg\",\"custom-theme.2d32a9de.js\",\"7Lbuq\",\"atlassian-light.e41467a8.js\",\"70Xzf\",\"atlassian-light-future.b3a0c94c.js\",\"7vLwj\",\"atlassian-light-increased-contrast.c905bbf0.js\",\"gdxOf\",\"atlassian-dark.68aa79de.js\",\"e6GIv\",\"atlassian-dark-future.b15283aa.js\",\"dcNlt\",\"atlassian-dark-increased-contrast.12125974.js\",\"lEZ5c\",\"atlassian-legacy-light.e1d70c50.js\",\"8sT7M\",\"atlassian-legacy-dark.c672db36.js\",\"25MQd\",\"atlassian-spacing.62f14d37.js\",\"7N1j7\",\"atlassian-typography.4e747e38.js\",\"5Nebg\",\"atlassian-shape.eb80495a.js\",\"8b0Br\",\"modal.9d2fc3a6.js\",\"8vPuH\",\"modal.80433e7c.js\",\"k0cqj\",\"esm.483ca9b8.js\",\"3kYzk\",\"atlassian-light.ec53b2c6.js\",\"4SBrD\",\"atlassian-light-future.040c24f4.js\",\"9JjvF\",\"atlassian-light-increased-contrast.7148f940.js\",\"aVUKw\",\"atlassian-dark.1230db01.js\",\"8wzVE\",\"atlassian-dark-future.e8f12063.js\",\"40kuy\",\"atlassian-dark-increased-contrast.a44e5e55.js\",\"aZlu4\",\"atlassian-legacy-light.3830bdb7.js\",\"8h6aK\",\"atlassian-legacy-dark.916ace95.js\",\"bNFL7\",\"atlassian-spacing.80c7d42f.js\",\"jSqFG\",\"atlassian-typography.541c0bd9.js\",\"9RdKm\",\"atlassian-shape.c1d0692c.js\",\"cwdbI\",\"custom-theme.45510dd4.js\",\"4hdf6\",\"action.5d30c4fe.js\",\"9Nq5w\",\"code.91751e76.js\",\"ePGFA\",\"date.b4a7a07b.js\",\"991q1\",\"decision.535b7fdd.js\",\"kLC4B\",\"divider.f9edc7cf.js\",\"hvmJX\",\"emoji.8ca8e5d1.js\",\"cEmjT\",\"images.205df1e7.js\",\"fOVzu\",\"layout.3da80c68.js\",\"a0uE3\",\"link.91a821ff.js\",\"csXda\",\"list-number.5b5ccd72.js\",\"3IfvT\",\"list.adc3ff4d.js\",\"fRMbE\",\"mention.77e440f3.js\",\"1enB6\",\"panel-error.d0efb376.js\",\"7RpMt\",\"panel-note.0403119e.js\",\"3pgks\",\"panel-success.9e03db09.js\",\"6l9qM\",\"panel-warning.05e7f785.js\",\"4Hqzu\",\"panel.b03fded0.js\",\"ktPG4\",\"quote.d4ab64f0.js\",\"k7byj\",\"status.d4437d8b.js\",\"YF1xP\",\"one-column-layout.19742d50.js\",\"2oceX\",\"two-column-layout.3a8532a3.js\",\"6DvU4\",\"three-column-layout.9bfca9ba.js\",\"d024f\",\"four-column-layout.e857ca90.js\",\"eWrXe\",\"five-column-layout.7f872ce4.js\",\"89orV\",\"feedback.18de6d0e.js\",\"dg3wD\",\"expand.a3b860e6.js\",\"gWJBp\",\"datasource-jira-issue.cb77e720.js\",\"4bbFn\",\"datasource-assets-objects.5c7bf40e.js\",\"dmUiG\",\"datasource-confluence-search.e8c04b93.js\",\"401Wt\",\"loom.fd6070c8.js\",\"cXmQo\",\"syncBlock.b501e4fe.js\",\"kuJIl\",\"atlassian-light.82322fdc.js\",\"dX2To\",\"atlassian-light-future.37e00009.js\",\"74iry\",\"atlassian-light-increased-contrast.5fb5add4.js\",\"lSCCa\",\"atlassian-dark.9a5097be.js\",\"9EnYa\",\"atlassian-dark-future.62751149.js\",\"7dF0M\",\"atlassian-dark-increased-contrast.13557dd8.js\",\"3GiJX\",\"atlassian-legacy-light.5d8b4b2e.js\",\"dte0L\",\"atlassian-legacy-dark.c6c58250.js\",\"fTcLg\",\"atlassian-spacing.9b7f7f0a.js\",\"blaC7\",\"atlassian-typography.390bb646.js\",\"jgUE0\",\"atlassian-shape.d1515a60.js\",\"4lxNA\",\"custom-theme.a115c3ec.js\",\"4zp3T\",\"cs.22dd6c87.js\",\"lDs9X\",\"da.d4e5bf93.js\",\"lJNEL\",\"de.1b454b83.js\",\"7UxPo\",\"en_GB.98b8119c.js\",\"cVGIp\",\"en_ZZ.a4da7e63.js\",\"kH9DA\",\"es.6ca1e4d0.js\",\"cbkwA\",\"fi.8c0f8dca.js\",\"1xrqJ\",\"fr.970d9f81.js\",\"8PwiF\",\"hu.4541b5ad.js\",\"9REdC\",\"it.5d251212.js\",\"bSFfJ\",\"ja.c859ed96.js\",\"aoOBZ\",\"ko.77123cf3.js\",\"fWwSy\",\"nb.15657b34.js\",\"4P6NK\",\"nl.6cc3dc86.js\",\"8tp99\",\"pl.0e67a3e8.js\",\"5isBg\",\"pt_BR.4507b4f6.js\",\"77Xeq\",\"ru.a4b9f23b.js\",\"fjXkb\",\"sv.a9b049a0.js\",\"5ppN6\",\"th.7ef25d41.js\",\"2ZZAw\",\"tr.d2d43c51.js\",\"8obpi\",\"uk.860145bd.js\",\"ceexF\",\"vi.09c1bb60.js\",\"acFsG\",\"zh_TW.285d3f68.js\",\"leOLb\",\"zh.2b3cecbd.js\",\"dfmLT\",\"link-picker.e48715b5.js\",\"b2fk5\",\"atlassian-light.bb576898.js\",\"aHnB1\",\"atlassian-light-future.a762a778.js\",\"jJ356\",\"atlassian-light-increased-contrast.80f160e1.js\",\"122v8\",\"atlassian-dark.06ff6387.js\",\"70xW7\",\"atlassian-dark-future.2694e55d.js\",\"7CVFq\",\"atlassian-dark-increased-contrast.c2f29dc7.js\",\"krq8D\",\"atlassian-legacy-light.23f742cb.js\",\"cJx16\",\"atlassian-legacy-dark.b575135b.js\",\"bmBcz\",\"atlassian-spacing.c0a6ff91.js\",\"13TCz\",\"atlassian-typography.a0d08b0f.js\",\"gIHSI\",\"atlassian-shape.b6fdaba9.js\",\"4L9Dv\",\"custom-theme.4f59c35c.js\",\"jPVOA\",\"atlassian-light.e998d3e1.js\",\"1NaxE\",\"atlassian-light-future.329857d0.js\",\"k4PkF\",\"atlassian-light-increased-contrast.cb6a10aa.js\",\"ocJPN\",\"atlassian-dark.9965abac.js\",\"aTqqL\",\"atlassian-dark-future.5b1800f9.js\",\"f4J8q\",\"atlassian-dark-increased-contrast.49974f38.js\",\"8Um41\",\"atlassian-legacy-light.710d311e.js\",\"8XTaB\",\"atlassian-legacy-dark.832e52cb.js\",\"iPkcz\",\"atlassian-spacing.f454c378.js\",\"jVTSt\",\"atlassian-typography.ad5dca1a.js\",\"d6yQp\",\"atlassian-shape.505bc30c.js\",\"5gLA6\",\"custom-theme.5ff12c57.js\",\"aeEhr\",\"atlassian-light.f044532f.js\",\"cfu1i\",\"atlassian-light-future.312023af.js\",\"ixMng\",\"atlassian-light-increased-contrast.5ce149ec.js\",\"3VkNQ\",\"atlassian-dark.3ae9e48a.js\",\"jqapF\",\"atlassian-dark-future.306ce7a8.js\",\"g1cjV\",\"atlassian-dark-increased-contrast.d2d74fd1.js\",\"90DnP\",\"atlassian-legacy-light.960afe22.js\",\"1NyBw\",\"atlassian-legacy-dark.e27eaa34.js\",\"3aFNO\",\"atlassian-spacing.51c63326.js\",\"5gSB9\",\"atlassian-typography.9a8a0289.js\",\"dW3IX\",\"atlassian-shape.bac11556.js\",\"fG4Nl\",\"custom-theme.51e3dfee.js\",\"ltlXq\",\"body.ec8d53ca.js\",\"48QfK\",\"esm.fe24b87e.js\",\"gPZkX\",\"sha256SimpleHasher.dade686d.js\",\"fKM6M\",\"simpleHasher.4839ed70.js\",\"lS4iW\",\"mobile-upload.c10daf99.js\",\"2OfXp\",\"esm.92f22ad8.js\",\"aFNpo\",\"browser.c58d378b.js\",\"faL9r\",\"atlassian-light.17027dd2.js\",\"bThcZ\",\"atlassian-light-future.8d28d8f8.js\",\"jgp9Y\",\"atlassian-light-increased-contrast.7acd2283.js\",\"fuD86\",\"atlassian-dark.219d685e.js\",\"6tdv9\",\"atlassian-dark-future.2c0563c0.js\",\"5sIHz\",\"atlassian-dark-increased-contrast.3d26792a.js\",\"ikR9S\",\"atlassian-legacy-light.54d19ace.js\",\"5A7oE\",\"atlassian-legacy-dark.d9d14eb4.js\",\"kOg9x\",\"atlassian-spacing.4b407b78.js\",\"d1QZr\",\"atlassian-typography.eb51be14.js\",\"8fB1m\",\"atlassian-shape.d6873bf3.js\",\"9xWHS\",\"custom-theme.f63b6f06.js\",\"3Nc0O\",\"media.487affc1.js\",\"lgIW5\",\"js.e7bc9557.js\",\"brZAs\",\"png-chunks-extract.c67566dc.js\",\"7Q4ht\",\"view.ce6f9bcb.js\",\"gFcxC\",\"view.bc0cbe71.js\",\"9WEDO\",\"view.0df8b2a0.js\",\"HRjDP\",\"esm.f69eabad.js\",\"6JxfS\",\"chat-widget-omni-channel-ui.b89d1c06.js\",\"eCxpc\",\"esm.75bfe1e2.js\",\"9gsM1\",\"windowedCodeBlock.c017f174.js\",\"b7QVN\",\"block.af05c0f0.js\",\"6I3A8\",\"block.07b03021.js\",\"5NFw4\",\"refractor.0a881806.js\",\"6SDIV\",\"windowedCodeBlock.f7ce8fce.js\",\"9SDS4\",\"codeBlock.5256975d.js\",\"eeXBJ\",\"taskList.fd33c618.js\",\"aIjNH\",\"taskItem.5c9efefd.js\",\"f8ExK\",\"decisionList.3c3285e3.js\",\"lSDKa\",\"decisionItem.2bd11be6.js\",\"5eAaY\",\"date.ff86726e.js\",\"fX2nW\",\"status.0fd134ad.js\",\"8qy29\",\"emoji.c42bf777.js\",\"cb7zB\",\"panel.de09c8ea.js\",\"hQeZ1\",\"embedCard.7610f332.js\",\"7KudU\",\"blockCard.3bd46dad.js\",\"3ybiy\",\"datasourceTableView.795a2c4a.js\",\"72Kd5\",\"inlineCard.e65ea25f.js\",\"lSyuz\",\"component-lazy.736622d7.js\",\"h0m3X\",\"audio-icon.315632e6.js\",\"5MTnN\",\"angle-brackets-icon.fde8b5cb.js\",\"joYbk\",\"folder-icon.b08d7928.js\",\"lalkF\",\"image-icon.960d8e7a.js\",\"6oF2d\",\"video-icon.be8c8699.js\",\"5gOEa\",\"lock-locked--lock-filled.ef2d021e.js\",\"3o0pf\",\"24.5146f3d1.js\",\"5BU3O\",\"24.cff8b7f5.js\",\"3Vtk4\",\"24.0c02afea.js\",\"3YZy9\",\"24.d445c346.js\",\"7WbIj\",\"24.4a8acfd5.js\",\"eUDKG\",\"24.f20cef9f.js\",\"2P2t2\",\"24.b0ac7994.js\",\"dbVND\",\"24.a634e50d.js\",\"5cevN\",\"24.a38bafac.js\",\"idwKF\",\"24.73f7b534.js\",\"jBDBf\",\"24.7c957dc4.js\",\"garab\",\"24.2962ebea.js\",\"kA15Q\",\"24.a05e1bd4.js\",\"36ooX\",\"attachment.8b63ddc4.js\",\"ehVjG\",\"task.36019ccb.js\",\"iNg9c\",\"component.0836c5a7.js\",\"ToOlT\",\"comment.0ef04a6d.js\",\"5DPYi\",\"eye-open--watch.76cba1cb.js\",\"aJpEe\",\"thumbs-up--like.64fee9bb.js\",\"8yHD5\",\"arrow-up.6977a3d0.js\",\"fPbsM\",\"question-circle--question.5a202aff.js\",\"4ivcO\",\"angle-brackets--code.223a8d46.js\",\"1pkve\",\"people-group--people.58eeb3d0.js\",\"l6fcu\",\"subtasks--subtask.555a1229.js\",\"bbdre\",\"goal-icon.fc436e5e.js\",\"j4IS4\",\"projects-icon.fd399c04.js\",\"bWl0R\",\"manual-triggers-modal.abf9daa5.js\",\"iQ1BA\",\"RelatedLinksModal.0d6b1f98.js\",\"053cf\",\"EmbedModal.2d18dd3a.js\",\"lcZFf\",\"custom-theme.c3a6bda1.js\",\"eZm2h\",\"atlassian-light.db7a14d6.js\",\"jYZcQ\",\"atlassian-light-future.8971c67d.js\",\"5zK6v\",\"atlassian-light-increased-contrast.308348f6.js\",\"kAYrf\",\"atlassian-dark.3635f2e1.js\",\"ftXjB\",\"atlassian-dark-future.e828be14.js\",\"dG5Lk\",\"atlassian-dark-increased-contrast.f0ba4460.js\",\"6WgiH\",\"atlassian-legacy-light.094e7564.js\",\"50slF\",\"atlassian-legacy-dark.ab3bbdf0.js\",\"4YHPB\",\"atlassian-spacing.194d5711.js\",\"gTefI\",\"atlassian-typography.40381118.js\",\"1EZt6\",\"atlassian-typography-adg3.1da861e0.js\",\"c5XTC\",\"atlassian-shape.cdaede68.js\",\"jLjAZ\",\"atlassian-shape-rounder.cad7108d.js\",\"8Utct\",\"atlassian-shape-roundest.0d2836c6.js\",\"f9Kcs\",\"atlassian-typography-modernized.8d46cb3b.js\",\"bQJhR\",\"atlassian-typography-refreshed.7a8d151f.js\",\"6p1nh\",\"atlassian-light-brand-refresh.85a577e8.js\",\"9yzVz\",\"atlassian-dark-brand-refresh.dc54ffb6.js\",\"jgcY4\",\"datasourceRenderFailedAnalyticsWrapper.238259ef.js\",\"dPYNj\",\"drag-onboarding.0ff9ab79.gif\",\"77hEj\",\"media.1ff6f0be.js\",\"hjx8Y\",\"media.962046e1.js\",\"bbVnl\",\"mobile-upload.4084d7ba.js\",\"kmnJr\",\"sha256SimpleHasher.1ea55bba.js\",\"2c8UN\",\"simpleHasher.cae6cdad.js\",\"hJYnA\",\"media-viewer-error-boundary.ae2802e3.js\",\"6utrM\",\"archive.5322aed7.js\",\"4fzrp\",\"archive.ab43260f.js\",\"bGUAd\",\"codeViewerRenderer.3f561faf.js\",\"hLPOa\",\"image.d60b924a.js\",\"bzau0\",\"video.ab5a9417.js\",\"lq662\",\"video.0edb85b3.js\",\"zHa9m\",\"mobile-upload.8644b51b.js\",\"7np7S\",\"sha256SimpleHasher.24cd96dc.js\",\"fbUxk\",\"simpleHasher.e829915d.js\",\"ebte3\",\"audio.d99ae065.js\",\"043rC\",\"doc.e27892d1.js\",\"auLb3\",\"codeViewer.a4025adb.js\",\"bttaS\",\"dist.d4307011.js\",\"1OvQm\",\"dist.10ccffd5.js\",\"6Kt0L\",\"dist.511ae387.js\",\"01GtD\",\"dist.016f7e52.js\",\"1KljQ\",\"dist.5a2c5f02.js\",\"23D1K\",\"dist.5be0756d.js\",\"5sBDe\",\"dist.8a86cb71.js\",\"cfsIz\",\"dist.46a21719.js\",\"goUFM\",\"dist.101c5dc4.js\",\"bhDxP\",\"dist.31a0efea.js\",\"i6Fxq\",\"dist.ca01820e.js\",\"7euOy\",\"dist.369e76dd.js\",\"fIdB5\",\"dist.73184ce3.js\",\"poOsA\",\"dist.7162a2da.js\",\"fJOYa\",\"dist.d7ebda6f.js\",\"inNnj\",\"dist.9e6a0198.js\",\"f8nMc\",\"dist.9b3cb337.js\",\"8aWee\",\"dist.dbf967dd.js\",\"ekyBH\",\"dist.c8eea06d.js\",\"10xwl\",\"dist.905d5ee3.js\",\"4p2if\",\"apl.0393ec23.js\",\"dBhHg\",\"asciiarmor.d88202a8.js\",\"2wZ9C\",\"asn1.15452946.js\",\"da8IW\",\"asterisk.66c4f134.js\",\"8oHtT\",\"brainfuck.192cf9d1.js\",\"lFgtK\",\"cobol.d205fc03.js\",\"cD5nw\",\"clike.7912f7d6.js\",\"iDLPx\",\"clojure.185c5ea2.js\",\"44L7z\",\"css.7218a159.js\",\"h3KkC\",\"cmake.4075a412.js\",\"51cli\",\"coffeescript.2dae5d8e.js\",\"8StR8\",\"commonlisp.b372551b.js\",\"6k3av\",\"cypher.f319f403.js\",\"imTMZ\",\"python.28905d9c.js\",\"8LylS\",\"crystal.2c879a2d.js\",\"24N01\",\"d.29c31b53.js\",\"hYP4d\",\"diff.37100e1a.js\",\"qM2T1\",\"dockerfile.2ae58ec1.js\",\"bLKFw\",\"dtd.1443dc52.js\",\"dbq97\",\"dylan.43c0c85c.js\",\"fGgZv\",\"ebnf.ac59c47a.js\",\"85Tc7\",\"ecl.9d5d2641.js\",\"19diC\",\"eiffel.504b25db.js\",\"aE8L0\",\"elm.aa063f73.js\",\"1OUqX\",\"erlang.1f5a3260.js\",\"iwfY1\",\"sql.d676c0b6.js\",\"UoFo6\",\"factor.ffb5df29.js\",\"6Kdlc\",\"fcl.81994d89.js\",\"iKykS\",\"forth.00abf07f.js\",\"gqg57\",\"fortran.9241a0c4.js\",\"iWmK9\",\"mllike.28bbbc79.js\",\"dDto5\",\"gas.2dd89f6a.js\",\"3B9QV\",\"gherkin.16bfeb89.js\",\"9GLE4\",\"groovy.dcec795a.js\",\"dJQax\",\"haskell.0ebe674e.js\",\"e7hU8\",\"haxe.807be87a.js\",\"9q3vN\",\"http.f70c350e.js\",\"fOtJf\",\"idl.6d7a73b3.js\",\"cVueU\",\"javascript.2eb7725f.js\",\"2n0nj\",\"jinja2.2302644b.js\",\"6gSx2\",\"julia.297dff5e.js\",\"jN9l6\",\"livescript.63b34849.js\",\"c8qRK\",\"lua.111daa0b.js\",\"3AND5\",\"mirc.562bac48.js\",\"b2cLX\",\"mathematica.3ef8ec71.js\",\"ZMHeR\",\"modelica.6c1a556a.js\",\"21nuu\",\"mumps.7e7b8b1a.js\",\"3thkD\",\"mbox.5aa9bf75.js\",\"hjATh\",\"nginx.474a044e.js\",\"hP1RP\",\"nsis.27f35240.js\",\"e3Tvg\",\"ntriples.c8a8ea4f.js\",\"cuS8X\",\"octave.76bfd437.js\",\"hsUFD\",\"oz.ef3206c2.js\",\"isxJL\",\"pascal.cb55734b.js\",\"9ewuc\",\"perl.6ecb9cc0.js\",\"5Jsj3\",\"pig.af011a2f.js\",\"1sko9\",\"powershell.6d6b6ce4.js\",\"lVfki\",\"properties.03a23e26.js\",\"jDcjw\",\"protobuf.e085ae95.js\",\"731OY\",\"pug.597befd3.js\",\"d8uo8\",\"puppet.dea39b96.js\",\"3l4vo\",\"q.3cf2e4d9.js\",\"kAUdd\",\"r.803529f6.js\",\"86Yhc\",\"rpm.06037d9e.js\",\"9O5VG\",\"ruby.6370a264.js\",\"4g5gT\",\"sas.85e9caba.js\",\"i8z7Z\",\"scheme.10f8d813.js\",\"aY3nK\",\"shell.5f098e4c.js\",\"02obJ\",\"sieve.473c3bd3.js\",\"kjCZL\",\"smalltalk.7a5d9b95.js\",\"egMAQ\",\"solr.b7877b70.js\",\"4iT61\",\"sparql.4de0a416.js\",\"dHap4\",\"spreadsheet.ca1f0ed6.js\",\"kUJcJ\",\"stylus.349cff3d.js\",\"do6Wl\",\"swift.228212da.js\",\"2APaA\",\"stex.b49850a2.js\",\"3e71W\",\"verilog.9d20c642.js\",\"kUsBB\",\"tcl.12aaecc2.js\",\"4tgAb\",\"textile.be0ade82.js\",\"jg4Z2\",\"tiddlywiki.5a582dae.js\",\"6x548\",\"tiki.bdc2877a.js\",\"c4c6S\",\"toml.edb75b5f.js\",\"gXiWJ\",\"troff.90064acb.js\",\"bz8sX\",\"ttcn.a248bd8a.js\",\"4Q9cH\",\"ttcn-cfg.099c516a.js\",\"dCV7Q\",\"turtle.021d5f9f.js\",\"e6cuf\",\"webidl.ef790507.js\",\"6TqOb\",\"vb.5fd22e6a.js\",\"eiHCt\",\"vbscript.0742bb50.js\",\"8Yvby\",\"velocity.9804c529.js\",\"1fTqC\",\"vhdl.1231bddd.js\",\"1Y4ow\",\"xquery.350cfd99.js\",\"6rGto\",\"yacas.76e537f1.js\",\"bceUd\",\"z80.0c68e64b.js\",\"jxhBg\",\"mscgen.bbc0f500.js\",\"2Vlxp\",\"dist.eb29f707.js\",\"hTW6s\",\"dist.b85af59e.js\",\"8oZD1\",\"svg.9964009e.js\",\"TCYhk\",\"media-viewer-error-boundary.34e0463e.js\",\"ldZsL\",\"custom-theme.4e2706be.js\",\"2nNUQ\",\"atlassian-light.c252a7a0.js\",\"4zCN5\",\"atlassian-light-future.7b345edf.js\",\"5Pg6h\",\"atlassian-light-increased-contrast.98458764.js\",\"4YrKn\",\"atlassian-dark.6961b932.js\",\"1vBIh\",\"atlassian-dark-future.cf338a19.js\",\"jAKsG\",\"atlassian-dark-increased-contrast.fddb9819.js\",\"1m1BW\",\"atlassian-legacy-light.b83d1384.js\",\"9NRKw\",\"atlassian-legacy-dark.ff1986c5.js\",\"1HjQP\",\"atlassian-spacing.67a27b23.js\",\"7Y1Sn\",\"atlassian-typography.856d20cb.js\",\"lo7dN\",\"atlassian-shape.10772280.js\",\"52I3j\",\"mobile-upload.900ec3bc.js\",\"7xpKa\",\"sha256SimpleHasher.64c64d81.js\",\"jczTX\",\"simpleHasher.77c56cdc.js\",\"1ktXd\",\"custom-theme.065b4f5b.js\",\"gDucL\",\"atlassian-light.4a4e7fb1.js\",\"a6MOq\",\"atlassian-light-future.7e1ceb53.js\",\"2Tken\",\"atlassian-light-increased-contrast.462f8a5b.js\",\"9Bj23\",\"atlassian-dark.31de17e4.js\",\"k8JN4\",\"atlassian-dark-future.ea71b10b.js\",\"1gG9N\",\"atlassian-dark-increased-contrast.40ffc1a6.js\",\"1GFBo\",\"atlassian-legacy-light.cce4f876.js\",\"knzKe\",\"atlassian-legacy-dark.e969ae73.js\",\"3VQLb\",\"atlassian-spacing.78f40e8e.js\",\"elYTq\",\"atlassian-typography.7b2485d0.js\",\"kI9sC\",\"atlassian-shape.ea6c688b.js\",\"2QqfK\",\"inlinePlayer.4ab90605.js\",\"hyTZl\",\"mediaGroup.8bba472c.js\",\"kD4ce\",\"mediaInline.4a7af22b.js\",\"18GuL\",\"esm.5e609443.js\",\"QIw1s\",\"mediaInlineCard.1aa43036.js\",\"e5DOm\",\"mediaInlineAnalyticsErrorBoundary.bcb04dc1.js\",\"WBFXC\",\"mediaSingle.98f60a9e.js\",\"cXRQB\",\"mention.292c3c96.js\",\"1HxWa\",\"cs.74b83ced.js\",\"31AZy\",\"da.6eec6093.js\",\"iHaOG\",\"de.82bd00e3.js\",\"lAeY6\",\"en.30b7d0d3.js\",\"kndgx\",\"en_GB.04b74dec.js\",\"bcVAn\",\"en_ZZ.d170a9d7.js\",\"gJwZN\",\"es.ba0b4ec8.js\",\"38gbK\",\"et.bc826aa8.js\",\"kvcKj\",\"fi.85c2a609.js\",\"7m2z1\",\"fr.176ffb8e.js\",\"lXSKI\",\"hu.4e66b20e.js\",\"bOwv9\",\"is.4d1bb8ab.js\",\"bQuYd\",\"it.ac9bfe78.js\",\"3wiTB\",\"ja.a01c94c1.js\",\"ax3N6\",\"ko.c4becb9b.js\",\"8Oko1\",\"nb.568f433d.js\",\"23DF8\",\"nl.7e46ce00.js\",\"cT9Lk\",\"pl.59f4a042.js\",\"1ErJf\",\"pt_BR.80a7130c.js\",\"d9Ufj\",\"pt_PT.a35e3de5.js\",\"kNjdB\",\"ro.d36db43e.js\",\"leNQu\",\"ru.d5c74474.js\",\"jyQ1P\",\"sk.c2b8bc99.js\",\"kRYc4\",\"sv.766db1be.js\",\"l8Gaq\",\"th.57e5b202.js\",\"2PFqk\",\"tr.cae2c63b.js\",\"asdIR\",\"uk.547cffbf.js\",\"6Wvi1\",\"vi.e2bd5e88.js\",\"igYVg\",\"zh_TW.169798f6.js\",\"2hiIW\",\"zh.d94d0b85.js\",\"fQr2e\",\"main.d5c051b2.js\",\"d9kMY\",\"atlassian-light.7cbe1660.js\",\"ijBxB\",\"atlassian-light-future.37a3cee0.js\",\"chFSP\",\"atlassian-light-increased-contrast.3f52943f.js\",\"lEqKc\",\"atlassian-dark.9c02cec0.js\",\"eeVVU\",\"atlassian-dark-future.9dac1cc2.js\",\"kTJ6e\",\"atlassian-dark-increased-contrast.51f8d167.js\",\"lwEG8\",\"atlassian-legacy-light.d48234e4.js\",\"jaBaa\",\"atlassian-legacy-dark.7b5606a6.js\",\"3YNRX\",\"atlassian-spacing.c39e3ec6.js\",\"dIwCG\",\"atlassian-typography.725a3447.js\",\"k9F8p\",\"atlassian-shape.4cc80cb8.js\",\"HEdLE\",\"custom-theme.78ed5c42.js\",\"5jLNe\",\"main.73951886.js\",\"51Wri\",\"atlassian-light.6e3edb63.js\",\"efC7W\",\"atlassian-light-future.86415983.js\",\"fK5l6\",\"atlassian-light-increased-contrast.757832a2.js\",\"6wYXz\",\"atlassian-dark.8ed0bf9e.js\",\"3vKFU\",\"atlassian-dark-future.034067d2.js\",\"lm4NP\",\"atlassian-dark-increased-contrast.e1ce3499.js\",\"gUaBF\",\"atlassian-legacy-light.3895cf7c.js\",\"fp1Ti\",\"atlassian-legacy-dark.77a58108.js\",\"hHBgS\",\"atlassian-spacing.a735c835.js\",\"4lJrm\",\"atlassian-typography.d4fe82b9.js\",\"gkuHl\",\"atlassian-shape.b113dfb1.js\",\"gXiCn\",\"custom-theme.250bc17e.js\",\"83Mvd\",\"atlassian-light.3b9df055.js\",\"lMNXa\",\"atlassian-light-future.ead6f0c2.js\",\"fkHHS\",\"atlassian-light-increased-contrast.6101033f.js\",\"b6L8e\",\"atlassian-dark.0f8987e7.js\",\"gvq57\",\"atlassian-dark-future.bbeb9483.js\",\"f6Ek6\",\"atlassian-dark-increased-contrast.da63372a.js\",\"gSlHt\",\"atlassian-legacy-light.98345983.js\",\"gPSPJ\",\"atlassian-legacy-dark.26f7de3e.js\",\"eO1NI\",\"atlassian-spacing.0ce81765.js\",\"lImLk\",\"atlassian-typography.1b20a2f3.js\",\"fBcsS\",\"atlassian-shape.72984650.js\",\"j4CCb\",\"custom-theme.0462b953.js\",\"37Xwv\",\"atlassian-light.bd2f4cb4.js\",\"3M0aX\",\"atlassian-light-future.08083e43.js\",\"5q947\",\"atlassian-light-increased-contrast.1bfb75f6.js\",\"6gSVu\",\"atlassian-dark.c564b4d5.js\",\"c7UVU\",\"atlassian-dark-future.fdac5b5e.js\",\"hb9eP\",\"atlassian-dark-increased-contrast.b7cfac75.js\",\"8U6fj\",\"atlassian-legacy-light.5f165552.js\",\"9EKJ6\",\"atlassian-legacy-dark.faad32db.js\",\"jJLxQ\",\"atlassian-spacing.b474e7e6.js\",\"gJfTO\",\"atlassian-typography.013b23c6.js\",\"ehMTv\",\"atlassian-shape.ccea5c6c.js\",\"6OiyO\",\"custom-theme.ce8c9141.js\",\"fCdeh\",\"AgentProfileCard.3b848a5b.js\",\"iAd6M\",\"auto-dev.32cbd874.js\",\"hZ56t\",\"auto-fix.0058ff9a.js\",\"9Q9B7\",\"auto-review.f072df40.js\",\"kyZNm\",\"backlog-buddy.180a1e9d.js\",\"cW2Sl\",\"comms-crafter.f834a269.js\",\"dPmlZ\",\"culture.0447ccba.js\",\"ff2ox\",\"customer-insight.0e2e2b4a.js\",\"lyT49\",\"decision-director.af9f6688.js\",\"g8ELo\",\"feature-flag-avatar.da9d7ea3.js\",\"2KQUN\",\"generic-avatar.2371fb1b.js\",\"5fVAX\",\"hire-writer.edd254ff.js\",\"Ol8P7\",\"marketing-message-maestro.bee02ded.js\",\"b5bBG\",\"my-user-manual.7bd4f67a.js\",\"gkbjq\",\"okr-oracle.ae86360b.js\",\"7aitr\",\"ops-agent.2909e614.js\",\"4I8sx\",\"pitch-perfector.8160dae8.js\",\"ivXfZ\",\"product-requirement.66edd188.js\",\"C2UU7\",\"release-notes.4394d9e5.js\",\"ARR1a\",\"research-scout.c6786901.js\",\"jrUTw\",\"rovo-dev.a1a4d287.js\",\"7ByjE\",\"social-media-scribe.e11df3a2.js\",\"bGLjm\",\"team-connection.86ef06fb.js\",\"7MGbX\",\"workflow-builder.258fa618.js\",\"fqNh3\",\"trial-guide.bcf97ad7.js\",\"hL5ii\",\"jsm-rovo-service-agent.372e1e50.js\",\"bsCTQ\",\"amplitude-agent.9d8122d4.js\",\"50DPv\",\"box-agent.a4d132ab.js\",\"2Cle5\",\"canva-agent.475eedec.js\",\"66Spl\",\"figma-agent.923d5686.js\",\"88X5j\",\"hubspot-agent.4887bead.js\",\"8Sl5W\",\"intercom-agent.0ad0109e.js\",\"f7x10\",\"gamma-agent.c69f1b77.js\",\"a4LPz\",\"lovable-agent.8fee449e.js\",\"fdoAI\",\"replit-agent.1f030a73.js\",\"hFuXZ\",\"rovo-agent.3328ed3d.js\",\"8BHGh\",\"AgentProfileCard.0ef5fc4f.js\",\"i9RPe\",\"ProfileCard.52f8bb1b.js\",\"eDmkW\",\"mention.39cac1de.js\",\"ksSEe\",\"Expand.2d6867d0.js\",\"heHnZ\",\"syncBlock.cc41414a.js\",\"2fXIk\",\"bodiedSyncBlock.f6dc94d3.js\",\"hRgLB\",\"custom-theme.21cc1395.js\",\"byZ4a\",\"atlassian-light.ce8abdb6.js\",\"1ELmn\",\"atlassian-light-future.6e128357.js\",\"aBUCf\",\"atlassian-light-increased-contrast.55646787.js\",\"bQx3Q\",\"atlassian-dark.77fd89bf.js\",\"b8N3J\",\"atlassian-dark-future.0e0b0327.js\",\"iCQuM\",\"atlassian-dark-increased-contrast.9ae0047b.js\",\"BCq7d\",\"atlassian-legacy-light.e8f7e4cf.js\",\"19txF\",\"atlassian-legacy-dark.b6ca3217.js\",\"jL3SY\",\"atlassian-spacing.263015ab.js\",\"ffSAL\",\"atlassian-typography.273deb3f.js\",\"f5483\",\"atlassian-shape.f1b893db.js\",\"8qSAx\",\"esm.34881297.js\",\"ezW9S\",\"custom-theme.ed701fe0.js\",\"6Vrou\",\"atlassian-light.44cc5120.js\",\"4Y5tC\",\"atlassian-light-future.9f448b7a.js\",\"i9zGm\",\"atlassian-light-increased-contrast.2b11dcff.js\",\"kgyir\",\"atlassian-dark.411478af.js\",\"a4BAi\",\"atlassian-dark-future.5c3aa0f0.js\",\"4dQS3\",\"atlassian-dark-increased-contrast.add4cc28.js\",\"eucmH\",\"atlassian-legacy-light.eabfde69.js\",\"l3fW8\",\"atlassian-legacy-dark.9b6d3430.js\",\"cCUKV\",\"atlassian-spacing.eb8fdfee.js\",\"a8Kvg\",\"atlassian-typography.1a690837.js\",\"12VsU\",\"atlassian-shape.01736245.js\",\"ius3F\",\"mobile-upload.43f41f59.js\",\"it8iU\",\"sha256SimpleHasher.aa9917ae.js\",\"l9mlb\",\"simpleHasher.b16aade4.js\",\"hCwjc\",\"esm.8ea13895.js\",\"1UZeW\",\"chat-widget-omni-channel-ui.ba37e50c.js\",\"hx68B\",\"chat-widget-customer-analytics.47aa0218.js\"]"));


//# sourceMappingURL=jira-product-discovery-page.d64e4cbe.js.map
